import { FormattedMessage } from "react-intl";
import clsx from "clsx";
import { LensTile, LensTileSize } from "../../homepage/LensHomePage/LensTile";
import styles from "./MoreLenses.module.css";
import gridStyles from "./ResponsiveGrid.module.css";
export function MoreLenses(props) {
    return (<div>
      <header>
        <h3 className={styles.title}>
          <FormattedMessage description="Title of the More Lenses module" defaultMessage="More Lenses"/>
        </h3>
      </header>
      <MoreLensesGrid {...props}/>
    </div>);
}
export function MoreLensesGrid(props) {
    const maxLenses = props.size === "large" ? 8 : 6;
    return (<div className={clsx(gridStyles.grid, gridStyles.gridLarge)}>
      {props.lenses.slice(0, maxLenses).map((lensDisplayInfo) => (<LensTile key={lensDisplayInfo.lensId} lensDisplayInfo={lensDisplayInfo} useBoldTitle enableVideoPreview={false} size={props.size === "large" ? LensTileSize.elastic : LensTileSize.small} lazyLoadImage/>))}
    </div>);
}
